import { NgModule} from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PdftemplateComponent } from './pdftemplate.component'
import { PdfComponent } from './pdf.component'


const routes: Routes = [
  {
    path: '', component: PdfComponent,
    children:[
      { path: 'pdftemplate/:token', component: PdftemplateComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PdfTemplateRoutingModule { }
